export const LOCATIONS = [
  "San Francisco",
  "London",
  "Nashville",
  "Gulfport",
  "Miami",
  "Boston",
  "San Diego",
  "Texas",
  "Portland",
  "Chicago",
  "Washington",
  "Dallas",
  "San Antonio",
  "Denver",
  "Las Vegas",
  "Franklin",
  "Orlando",
  "Pittsburgh",
  "New York",
  "Memphis",
  "Phoenix",
  "Palm Springs",
];

export const CATEGORIES = [
  "Fashion",
  "Beauty",
  "Lifestyle",
  "Tech",
  "Fitness",
  "Food",
  "Travel",
  "Gaming",
  "UGC",
  "Education",
  "Business",
  "Finance",
  "Parenting",
  "Pets",
  "Photography",
  "Videography",
];

export const LANGUAGES = [
  "English",
  "Hindi",
  "Tamil",
  "Telugu",
  "Bengali",
  "Marathi",
];

// Tier definitions with follower ranges
export const TIERS = [
  { label: "Nano", value: "nano", min: 0, max: 10000 },
  { label: "Micro", value: "micro", min: 10000, max: 100000 },
  { label: "Macro", value: "macro", min: 100000, max: 1000000 },
  { label: "Mega", value: "mega", min: 1000000, max: 10000000 },
];

// Engagement Rate ranges for quick selection (multi-select enabled)
export const ENGAGEMENT_RANGES = [
  { label: "Below 1%", value: "below1", min: 0, max: 1 },
  { label: "1% – 3%", value: "1to3", min: 1, max: 3 },
  { label: "3% – 6%", value: "3to6", min: 3, max: 6 },
  { label: "6%+", value: "above6", min: 6, max: 1000 },
];

export const GENDERS = [
  { label: "Male", value: "male" },
  { label: "Female", value: "female" },
  { label: "Unknown", value: "unknown" },
];
